import { MolhamTargetableMetadata } from "apiTypes";
import dayjs from "dayjs";
import Link from "next/link";
import StarsSkeleton from "./StarsSkeleton";
import BodyLock from "utils/bodyLock";
type Props = {
	detail: MolhamTargetableMetadata;
	closeOnLinkClick?: boolean;
};

export default function ValueParser({ detail }: Props) {
	if (detail.name === "donor_email") {
		if (typeof detail?.value !== "string") {
			return null;
		}
		return (
			<span
				dir="auto"
				className="text-muted d-flex align-items-center "
				style={{ lineHeight: 0 }}
			>
				{detail?.value.split("*")[0]}{" "}
				<StarsSkeleton stars={detail?.value.split("@")[0]} max={10} />
				{"@"}
				<StarsSkeleton stars={detail?.value.split("@")[1]} max={10} />
			</span>
		);
	}
	if (detail.name === "donor_name") {
		if (typeof detail?.value !== "string") {
			return null;
		}
		return (
			<span
				dir="auto"
				className="text-muted d-flex align-items-center "
				style={{ lineHeight: 0 }}
			>
				{detail?.value.split("*")[0]}

				<StarsSkeleton stars={detail?.value} max={15} />
			</span>
		);
	}
	if (detail?.type == "link" && detail?.path?.web) {
		const path = detail.path.web.startsWith("/") ? detail.path.web : "/" + detail.path.web;
		return (
			<Link
				href={path}
				className="meta-link text-primary"
				onClick={() => {
					BodyLock.unlock();
				}}
			>
				{detail?.value}
			</Link>
		);
	}
	if (detail?.type === "datetime") {
		return (
			<span
				dir="auto"
				className="text-muted d-flex align-items-center "
				style={{ lineHeight: 0 }}
			>
				{" "}
				{/* format arabic numbers not indian */}
				{dayjs(detail?.value).locale("en").format("DD/MM/YYYY")}
			</span>
		);
	}
	return <span className="ms-1 text-muted"> {detail.value}</span>;
}
